import { VendInfo } from "./vend-info";
import {HoursOfOperation} from "./hours-of-operation";
import {HubModule} from "./hub-module";
import * as _ from "lodash";

export class Machine {
    id: string;
    name: string;
    serialNumber: string;
    status: string;
    displayStatus: string;
    macAddress: string;
    ipAddress: string;
    role: string;
    location: string;
    phone: string;
    saveTickets: boolean;
    maxCapsuleDispense: number;
    diagnosticState: string;
    hubModules: HubModule[] = [];
    currentVends: VendInfo[] = [];
    lifetimeVends: VendInfo[] = [];
    vendFailures: VendInfo[] = [];
    currentVendTotal: number = 0;
    lifetimeVendTotal: number = 0;
    vendFailureTotal: number = 0;
    hoursOfOperation: HoursOfOperation;
    accountId: string;
    lastCommunication: Date;
    lastStatReset: Date;

    fromJson(dict: any): Machine {
        this.id = dict.id;
        this.name = dict.name;
        this.serialNumber = dict.serialNumber;
        this.status = dict.status;
        this.displayStatus = dict.statusDescription;
        this.macAddress = dict.macAddress || "";
        this.ipAddress = dict.ipAddress || "";
        this.role = dict.role;
        this.maxCapsuleDispense = dict.maxCapsuleDispense;
        this.phone = dict.phone;
        this.saveTickets = dict.saveTickets;
        this.location = dict.location;
        this.diagnosticState = dict.diagnosticState || 'none';
        this.hoursOfOperation = dict.hoursOfOperation;
        this.accountId = dict.accountId;
        this.lastCommunication = dict.lastCommunication;
        this.lastStatReset = dict.lastStatReset;

        this.currentVendTotal = 0;
        this.lifetimeVendTotal = 0;
        this.vendFailureTotal = 0;

        if (dict.currentVends) {
            for (let vendObj of dict.currentVends) {
                let vend = new VendInfo().fromJson(vendObj);
                this.currentVends.push(vend);
                this.currentVendTotal += vend.value;
            }
        }

        if (dict.lifetimeVends) {
            for (let vendObj of dict.lifetimeVends) {
                let vend = new VendInfo().fromJson(vendObj);
                this.lifetimeVends.push(vend);
                this.lifetimeVendTotal += vend.value;
            }
        }

        if (dict.vendFailures) {
            for (let vendObj of dict.vendFailures) {
                let vend = new VendInfo().fromJson(vendObj);
                this.vendFailures.push(vend);
                this.vendFailureTotal += vend.value;
            }
        }

        if (dict.hubModules) {
            this.hubModules = [];
            for (let hubModDict of dict.hubModules) {
                let hubModule = new HubModule().fromJson(hubModDict);
                this.hubModules.push(hubModule);
            }
            this.hubModules = _.sortBy(this.hubModules, ['type', 'sortOrder']);
        }

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/machine.ts